export default "__VITE_ASSET__Ct3197Lm__"